import { assignShipToAddressModalStyles } from "@insite/content-library/Widgets/UserSetup/AssignShipToAddressModal"
import {userSetupHeaderStyles} from "@insite/content-library/Widgets/UserSetup/UserSetupHeader"
import { userSetupStatusStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupStatus"
import { COLORS } from "@tCentro/theme/design"
import { css } from "styled-components"

userSetupHeaderStyles.assignShipToAddressButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
}

userSetupHeaderStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}

userSetupStatusStyles.wrapper = {
    css: css`
            padding-bottom: 15px;
            font-weight: 400;
            span[role=checkbox] {
                border: 2px solid #9E9D9E !important;
                border-radius: 0 !important;
                &:focus {
                    box-shadow: none !important;
                }
                &[aria-checked=true]{
                    background: none !important;
                    color: ${COLORS.black} !important;
                    border: 2px solid ${COLORS.black} !important;
                }
        }
        `,
}

assignShipToAddressModalStyles.assignShippingAddressCheckbox = {
    css: css`
    span[role=checkbox] {
        border: 2px solid #9E9D9E !important;
        border-radius: 0 !important;
        &:focus {
            box-shadow: none !important;
        }
        &[aria-checked=true]{
            background: none !important;
            color: ${COLORS.black} !important;
            border: 2px solid ${COLORS.black} !important;
        }
    }
    `,
}

assignShipToAddressModalStyles.saveButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
}